import React, { FC, useEffect, useState } from "react";
import useSelector from "src/hooks/useSelector";
import DrawerItem from "../Drawer/DrawerItem";
import { FontAwesomeIcons } from "src/constants/fontAwesomeIcons";
import useDispatch, { useActionCreator } from "src/hooks/useDispatch";
import * as NavigationActions from "../../../actions/navigation";

import "./MobileDrawer.scss";

const MobileDrawer: FC = () => {
    //
    // -- States --
    const [canScrollToTop, setCanScrollToTop] = useState<boolean>(false);
    const [canScrollToBottom, setCanScrollToBottom] = useState<boolean>(false);

    //
    // -- Hooks --
    const isOpen = useSelector((state) => state.navigation.isOpen);
    const drawerItems = useSelector((state) => state.navigation.drawerItems);
    const dispatch = useDispatch();
    const toggleNavigationDrawer = useActionCreator(
        NavigationActions.ToggleNavigationDrawer,
        dispatch
    );

    // Method to render the drawer items
    const renderDrawerItems = () => {
        return drawerItems?.map((item, index) => (
            <li
                className="drawer-list-item"
                key={`list-item-${item.title}-${index}`}
            >
                <DrawerItem
                    key={`item-${item.title}-${index}`}
                    navItem={item}
                />
            </li>
        ));
    };

    // Auto close mobile draw if drawer is open & no side menu
    useEffect(() => {
        if (isOpen && drawerItems?.length < 1 && window.screen.width <= 992) {
            toggleNavigationDrawer(!isOpen);
        }
    }, [drawerItems, isOpen, window.screen.width]);

    useEffect(() => {
        window.addEventListener("scroll", handleScroll, { passive: true });

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const handleScroll = () => {
        const position = window.scrollY;

        position > 150 ? setCanScrollToTop(true) : setCanScrollToTop(false);
        position > 250 &&
        position < document.body.scrollHeight - screen.availHeight
            ? setCanScrollToBottom(true)
            : setCanScrollToBottom(false);
    };

    return (
        <div
            className="mobile-drawer-container"
            style={{
                width: isOpen ? "240px" : "64px",
                display: isOpen && drawerItems?.length > 0 ? "block" : "none",
            }}
        >
            <div
                className="mobile-drawer-fixed-container"
                style={{
                    width: isOpen ? "240px" : "0px",
                }}
            >
                <div style={{ height: "65px" }}></div>
                <ul className="drawer-list">
                    {renderDrawerItems()} {/** Drawer items */}
                </ul>
            </div>

            {/** Auto scroll nav buttons */}
            <div
                className="mobile-drawer-footer-container"
                style={{
                    width: isOpen ? "240px" : "0px",
                    overflow: "hidden",
                }}
            >
                <ul className="mobile-drawer-list">
                    <li
                        className="mobile-drawer-list-item mobile-border-top"
                        onClick={() => {
                            window.scrollTo({ top: 0, behavior: "smooth" });
                        }}
                        style={{
                            opacity: canScrollToTop ? "1" : "0",
                            display: canScrollToTop ? "flex" : "none",
                        }}
                    >
                        <DrawerItem
                            navItem={{
                                icon: FontAwesomeIcons.Duotone.ARROWUPTOLINE,
                                title: "Return to Top",
                            }}
                        />
                    </li>
                    <li
                        className="mobile-drawer-list-item mobile-border-top"
                        onClick={() => {
                            window.scrollTo({
                                top: document.body.scrollHeight,
                                behavior: "smooth",
                            });
                        }}
                        style={{
                            opacity: canScrollToBottom ? "1" : "0",
                            display: canScrollToBottom ? "flex" : "none",
                        }}
                    >
                        <DrawerItem
                            navItem={{
                                icon: FontAwesomeIcons.Duotone.ARROWDOWNTOLINE,
                                title: "Go to Bottom",
                            }}
                        />
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default MobileDrawer;
